import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    min-width: 280px;\n    max-width: 360px;\n    cursor: default;\n    outline: none;\n    user-select: none;\n\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { getPropsBlocker } from '../../../../utils';

var headerNavigationMenuContentRootStyle = function headerNavigationMenuContentRootStyle(_ref) {
  var HeaderNavigationMenuContent = _ref.theme.componentOverrides.HeaderNavigationMenuContent;
  return HeaderNavigationMenuContent.Root.base;
};

export var HeaderNavigationMenuContentRoot = styled.div.withConfig(getPropsBlocker())(_templateObject(), headerNavigationMenuContentRootStyle);